import { render, staticRenderFns } from "./InternalThresholds.vue?vue&type=template&id=f426eb10&scoped=true"
import script from "./InternalThresholds.vue?vue&type=script&lang=js"
export * from "./InternalThresholds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f426eb10",
  null
  
)

export default component.exports